import { Guid } from "@/Common/Models/Guid";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum PatientLabsInboxViewButtonRegistryComponentId {
    LaunchOlisButton = 0,
    DigitalHealthDrugRepository = 1
}

type PatientLabsInboxViewButtonRegistryProps = {
    patientContactId: Guid;
    providerContactFacetId: Guid;
};

class PatientLabsInboxViewButtonRegistry extends BaseComponentRegistry<PatientLabsInboxViewButtonRegistryComponentId, PatientLabsInboxViewButtonRegistryProps> {}

const PatientLabsInboxViewButtonRegistryView = createRegistryListView(() => PatientLabsInboxViewButtonRegistry.getInstance());

export {
    PatientLabsInboxViewButtonRegistry,
    PatientLabsInboxViewButtonRegistryComponentId,
    PatientLabsInboxViewButtonRegistryView
};
